import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import obtieneDatos from '../tools/obtieneDatosCookiesUsuario';
import DevuelveProcesos from './devuelveProcesos';
import DevuelveEtapas from './devuelveEtapas';
import { Spinner } from 'reactstrap';
import axios from 'axios';
import Ingresos from './Ingresos';
import convierteDataProvincia from './convierteDataProvincia';
import CargaMasiva from "./CargaMasiva";
import CargaDNI from "./CargaDNI";
import Modal from 'react-modal';
import socket from "../tools/socke";
import ProcesosViewer from "../Inscripciones/ProcesosViewer";

function Procesos() {
  const Usuario = obtieneDatos();
  const navigate = useNavigate();

  useEffect(() => {
    if (!Usuario.id) {
      alert("Acceso no autorizado");
      window.location.href = './';
    }
  }, [Usuario]);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      width: "auto",
      height: "auto"
    },
  };

  const [procesos, setProcesos] = useState([]);
  const [etapas, setEtapas] = useState([]);
  const [etapaSeleccionada, setEtapaSeleccionada] = useState(null);
  const [procesoSeleccionado, setProcesoSeleccionado] = useState(null);
  const [muestroCargaMasiva, setMuestroCargaMasiva] = useState(false);
  const [cargando, setCargando] = useState(false);
  const [veoAsignacionEtapa,setVeoAsignacionEtapa]=useState(true)
   
    

  // Cargar procesos al inicio
  useEffect(() => {
    cargarProcesos();
  }, []);

  const cargarProcesos = async () => {
    setCargando(true);
    try {
      const client = axios.create({
        baseURL: process.env.REACT_APP_BASEURL + "procesos/muestraProcesos"
      });
      const res = await client.post('/');
      setProcesos(res.data || []);
    } catch (error) {
      console.error("Error al cargar procesos:", error);
    } finally {
      setCargando(false);
    }
  };

  // Cargar etapas cuando cambia el proceso seleccionado
  useEffect(() => {
    if (procesoSeleccionado) {
      cargarEtapasDelProceso(procesoSeleccionado);
    }
  }, [procesoSeleccionado]);

  
  useEffect(() => {
    if (etapaSeleccionada) {
//       console.log("Etapa seleccionada:", etapaSeleccionada);
   
    }
  }, [etapaSeleccionada]);

  const cargarEtapasDelProceso = async (proceso) => {
    setCargando(true);
    try {
      const client = axios.create({
        baseURL: process.env.REACT_APP_BASEURL + "procesos/muestraEtapas"
      });
      const res = await client.post('/' + proceso.id);
      setEtapas(res.data || []);
    } catch (error) {
      console.error("Error al cargar etapas:", error);
    } finally {
      setCargando(false);
    }
  };

  const crearProceso = () => {
    const valor = window.prompt("Ingrese el nombre del proceso!");
    if (!valor) return;

    const ultimaLetra = valor.slice(-1);
    if (ultimaLetra.toLowerCase() === 's') {
      return alert("El nombre no puede terminar en la letra 's'");
    }

    const nuevoProceso = {
      nombre: "proceso_" + valor,
      proceso: valor,
      escuela: "Escuela de Policia",
      api: "proceso_" + valor + "s",
      etapa: "inscripcion",
      estado: "Activo",
      esComplemento:"No"
      
    };

    crearNuevoProceso(nuevoProceso);
  };

  const crearNuevoProceso = async (promocion) => {
    try {
      const client = axios.create({
        baseURL: process.env.REACT_APP_BASEURL + "procesos/crearProceso"
      });
      await client.post('/', promocion);
      alert("Proceso " + promocion.nombre + " creado correctamente");
      cargarProcesos();
    } catch (error) {
      console.error("Error al crear proceso:", error);
    }
  };

  const crearEtapaProceso = () => {
    const valor = window.prompt("Ingrese el nombre de la Etapa!");
    if (!valor) return;

    const ultimaLetra = valor.slice(-1);
    if (ultimaLetra.toLowerCase() === 's') {
      return alert("El nombre no puede terminar en la letra 's'");
    }

    const nuevaEtapa = {
      nombreEtapa: valor,
      nombre: `etapa_${valor}_Proceso_${procesoSeleccionado.proceso}`,
      idProceso: procesoSeleccionado.id,
      escuela: "Escuela de Policia",
      apiEtapa: `etapa_${valor}_Proceso_${procesoSeleccionado.proceso}s`,
      estadoEtapa: "Activo"
    };

    crearNuevaEtapa(nuevaEtapa);
  };

  const crearNuevaEtapa = async (etapa) => {
    try {
      const client = axios.create({
        baseURL: process.env.REACT_APP_BASEURL + "procesos/crearEtapaProceso"
      });
      await client.post('/', etapa);
      alert("Etapa " + etapa.nombreEtapa + " creada correctamente");
      cargarEtapasDelProceso(procesoSeleccionado);
    } catch (error) {
      console.error("Error al crear etapa:", error);
    }
  };

  const modificoEstado = async (grupo) => {
    try {
      const hora = document.getElementById("hora").value;
      const sede = document.getElementById("sede").value;
      const fecha = document.getElementById("fecha").value;
      const ubicacionMaps = document.getElementById("ubicacionMaps").value;

      setCargando(true);
      const mando = await axios.post(process.env.REACT_APP_BASEURL+`procesos/creaPresente/${etapaSeleccionada.apiEtapa}`, {
        grupo,
        proceso: procesoSeleccionado.api,
        horaConvocado: hora,
        fechaConvocado: fecha,
        sedeConvocado: sede,
        ubicacionMaps
      });

      if (mando.data === "No se agrego nada") {
        alert(mando.data);
      } else {
        alert(`Se agregaron ${mando.data.length} postulantes nuevos a la etapa seleccionada`);
      }
    } catch (error) {
      console.error("Error al modificar estado:", error);
    } finally {
      setCargando(false);
    }
  };

  const actualizoEstado = async (grupo) => {
    try {
      await axios.post(`${process.env.REACT_APP_BASEURL}procesos/modificaEstadoMasivo?estado=${etapaSeleccionada.nombreEtapa}`, {
        proceso: procesoSeleccionado.api,
        grupo
      });
      alert("Estado actualizado");
    } catch (error) {
      console.error("Error actualizando estado masivo:", error);
    }
  };

  const volver = () => navigate('/usuarioLogueado');

  return (
    <>
      <Modal isOpen={cargando} style={customStyles} ariaHideApp={false}>
        Cargando... <Spinner />
      </Modal>



      <div >

        
        <ProcesosViewer/>
       
    {/*   
        <div style={{ backgroundColor: "grey", minWidth: "358px" }}>
          {procesos.length > 0 ? (
            <DevuelveProcesos cosas={procesos} myID={setProcesoSeleccionado} />
          ) : (
            "Sin procesos encontrados"
          )}
        </div>

        {etapas.length > 0 && (
          <div style={{ backgroundColor: "grey", minWidth: "358px" }}>
             {Usuario.destino === "7" &&procesoSeleccionado && (
          <>  <button className="btn btn-danger" onClick={crearEtapaProceso}>Crear Etapa</button></>)}    
            <DevuelveEtapas cosas={etapas} obtengoEtapa={setEtapaSeleccionada} />
          </div>
        )}

        {Usuario.destino === "7" && procesoSeleccionado && (
          <>  
            {muestroCargaMasiva && (
              <CargaMasiva datosObtenidos={convierteDataProvincia} myID={() => setMuestroCargaMasiva(false)} />
            )}
          
          </>
        )}

        {etapaSeleccionada && (
          <>
            <h1 onClick={()=>setVeoAsignacionEtapa(!veoAsignacionEtapa)}>Etapa Seleccionada: {etapaSeleccionada.nombreEtapa}</h1>

            {Usuario.destino === "7" && veoAsignacionEtapa&&(
              <>
                <CargaDNI datos={modificoEstado} />
                <input placeholder="Sede" id="sede" />
                <input placeholder="Ubicacion" id="ubicacionMaps" />
                <input placeholder="Fecha" id="fecha" />
                <input placeholder="Hora" id="hora" />
                <div>
                  Actualizo Estados
                  <CargaDNI datos={actualizoEstado} />
                </div>
              </>
            )}

                 <Ingresos datos={procesoSeleccionado} etapa={etapaSeleccionada} />
          </>
        )}*/} 
      </div>
    </>
  );
}

export default Procesos;
